// Track the last reloaded path to prevent circular reloads
let lastReloadedPath = null;
let isReloading = false;

export const setActiveCampaignEmail = (email) => {
  try {
    if (window.vgo && email) {
      window.vgo('setEmail', email);
      window.vgo('update');
      window.vgo('process', 'allowTracking');
      console.log('ActiveCampaign email set:', email);
    } else {
      console.warn('ActiveCampaign vgo not available or email not provided');
    }
  } catch (error) {
    console.error('Error setting ActiveCampaign email:', error);
  }
};

export const reloadPageForRouteChange = (currentPath) => {
  try {
    if (isReloading) {
      return;
    }

    if (currentPath !== lastReloadedPath) {
      lastReloadedPath = currentPath;
      isReloading = true;
      console.log('Reloading page for route change:', currentPath);

      sessionStorage.setItem('lastReloadedPath', currentPath);

      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  } catch (error) {
    console.log('Error reloading page for route change:', error);
    isReloading = false;
  }
};

export const initializeReloadTracking = () => {
  const storedPath = sessionStorage.getItem('lastReloadedPath');
  if (storedPath) {
    lastReloadedPath = storedPath;
    console.log('Initialized reload tracking with path:', storedPath);
  }
  isReloading = false;
};

export const resetReloadTracking = () => {
  lastReloadedPath = null;
  isReloading = false;
  sessionStorage.removeItem('lastReloadedPath');
  console.log('Reload tracking reset');
};